import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgBalanceFilled = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      d="M9.164 1.427a.2.2 0 0 1 .283 0l4.182 4.182a.1.1 0 0 1-.07.17H5.052a.1.1 0 0 1-.07-.17zM18.615 5.78a.1.1 0 0 0 .07-.171l-3.252-3.253a.1.1 0 0 0-.142 0l-1.32 1.321a.1.1 0 0 0 0 .142L15.9 5.75a.1.1 0 0 0 .072.03zM1.249 7.286a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-4.007h-8.18a3.484 3.484 0 0 1 0-6.967h8.18V8.286a1 1 0 0 0-1-1z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M15.044 13.836a1.96 1.96 0 1 0 0 3.919h9.006a.2.2 0 0 0 .2-.2v-3.519a.2.2 0 0 0-.2-.2zm.205 2.96a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgBalanceFilled);
export default Memo;
